import React from 'react';
import classNames from 'classnames';
import { Heading } from '../../components';
import { richText } from '../../util/richText';

import css from './CustomExtendedDataSection.module.css';

const MIN_LENGTH_FOR_LONG_WORDS = 20;

const SectionText = props => {
  const {
    text,
    heading,
    headingClassName,
    className,
    rootClassName,
    showAsIngress = false,
  } = props;
  const textClass = showAsIngress ? css.ingress : css.text;

  // Split into real paragraphs so CSS can control inter-paragraph spacing
  const paragraphs = text ? text.split(/\n\s*\n/) : [];
  const renderContent = paragraphs.length > 1
    ? paragraphs.map((para, i) => {
        const content = richText(para.trim(), {
          linkify: true,
          longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS,
          longWordClass: css.longWord,
          breakChars: '/',
        });
        return <p key={i} className={textClass}>{content}</p>;
      })
    : (() => {
        const content = richText(text, {
          linkify: true,
          longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS,
          longWordClass: css.longWord,
          breakChars: '/',
        });
        return <p className={textClass}>{content}</p>;
      })();

  const classes = classNames(rootClassName || css.sectionText, className);

  return text ? (
    <section className={classes}>
      {heading ? (
        <Heading as="h2" rootClassName={css.sectionHeading} className={headingClassName}>
          {heading}
        </Heading>
      ) : null}
      {renderContent}
    </section>
  ) : null;
};

export default SectionText;
